import React from 'react'

// Styles
import './index.scss'


const CaseStudy = () => {
  return (
    <div className="case-study-parent">
      <div className="page-banner bg-page-banner vh-center">
        <div className="banner-content">
          <h2>Case Study</h2>
        </div>
      </div>

      <div className="container">
        <div className="page-section">
          <h2 style={{ fontStyle: 'italic' }}>Coming Soon...</h2>
        </div>
      </div>
    </div>
  )
}

export default CaseStudy